/* eslint-disable react/jsx-no-target-blank */
import React, {Fragment} from 'react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {adminSidebarItems} from "../../../../../app/mock/sidebar";

const SidebarMenuMain = () => {
  return (
      <>
        {
          (adminSidebarItems)?.map((item, index) => (
              <Fragment key={index}>
                <div className='menu-item'>
                  <div className='menu-content pb-2'>
                    <span className='menu-section text-white text-uppercase fs-8 ls-1'>{item.header}</span>
                  </div>
                </div>
                {
                  item.items.map((item, index) => (
                      <SidebarMenuItem key={index} to={item.href || ""} icon={item.icon} title={item.title || ""}
                                       fontIcon={item?.fontIcon}/>
                  ))
                }
              </Fragment>
          ))
        }
      </>
  )
}

export {SidebarMenuMain}
